import React, { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { OrderInfoType, OrderInfoType as OrderInfoTypeType } from 'adoms-common-lib';
import { CustomerURLInformationUtil } from './customerURLInformationUtil';
import { Box, CircularProgress } from '@mui/material';

type OrderInfoTypeSwitchRouteProps = {
    business: React.ReactElement;
    customer: React.ReactElement;
    maritime: React.ReactElement;
};

const OrderInfoTypeSwitchRoute: React.FC<OrderInfoTypeSwitchRouteProps> = (props) => {
    const params = useParams<{ urlId: string }>();
    const [orderInfoType, setOrderInfoType] = useState<OrderInfoTypeType | null>(null);
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        setIsLoaded(false);
        const urlId = params.urlId;
        if (!urlId) {
            setOrderInfoType(null);
            setIsLoaded(true);
            return;
        }

        const util = CustomerURLInformationUtil.instance;
        const customerURLInformation = util.getCustomerURLInformation();
        setOrderInfoType(customerURLInformation?.orderInfoType ?? null);
        setIsLoaded(true);
    }, [params.urlId]);

    if (!isLoaded) {
        return (
            <Box
                sx={{
                    minHeight: '40vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <CircularProgress />
            </Box>
        );
    }

    if (!orderInfoType) {
        return <Navigate to="/forbidden403Page" />;
    }

    switch (orderInfoType) {
        case OrderInfoType.BusinessOrderInfo:
            return props.business;
        case OrderInfoType.CustomerOrderInfo:
            return props.customer;
        case OrderInfoType.MaritimeOrderInfo:
            return props.maritime;
        default:
            return <Navigate to="/forbidden403Page" />;
    }
};

export default OrderInfoTypeSwitchRoute;
